export default __webpack_public_path__ + "public/images/home/intro/redStar.png?29ab2e3c";